import React from "react";

import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

const CustomTooltip = withStyles(() => ({
  tooltip: props => ({
    marginTop: "5px",
    borderRadius: "2px",
    padding: "2px 10px 1px",
    maxwidth: props.maxwidth || 800,
    font: "var(--size-9px)/var(--size-16px) var(--font-family-diodrum_semi-bold)"
  })
}))(Tooltip);

const PrimaryTooltip = withStyles(() => ({
  tooltip: {
    color: "var(--color-primary)",
    backgroundColor: "var(--color-pale-teal)"
  }
}))(CustomTooltip);

const DisabledTooltip = withStyles(() => ({
  tooltip: {
    color: "var(--color-medium-grey)",
    backgroundColor: "var(--color-light-grey)"
  }
}))(CustomTooltip);

const SecondaryTooltip = withStyles(() => ({
  tooltip: {
    color: "var(--color-white)",
    backgroundColor: "var(--color-primary)"
  }
}))(CustomTooltip);

const ErrorTooltip = withStyles(() => ({
  tooltip: {
    color: "var(--color-red)",
    backgroundColor: "var(--color-error-tooltip-bg)"
  }
}))(CustomTooltip);

const WarningTooltip = withStyles(() => ({
  tooltip: {
    color: "var(--color-orange)",
    backgroundColor: "var(--color-orange-tooltip-bg)"
  }
}))(CustomTooltip);

const EmptyTooltip = withStyles(() => ({
  tooltip: {
    display: "none"
  }
}))(CustomTooltip);

const Tooltip_Types = {
  primary: PrimaryTooltip,
  disabled: DisabledTooltip,
  secondary: SecondaryTooltip,
  warning: WarningTooltip,
  error: ErrorTooltip,
  none: EmptyTooltip
};

export const DupontTooltip = props => <>{props.title && React.createElement(Tooltip_Types[props.type], { ...props })}</>;
